import { getTableAudience } from '../services';
export const fetchAudience = (params) => getTableAudience(params).then(response => formatAudience(response?.data));
const formatAudience = (response) => ({
    success: response.success,
    data: formatDataTable(response.data, response.series),
    columns: formatHeaderTable(response.series),
    totalCount: response.totalCount,
});
const formatDataTable = (data, columns) => {
    return data.map(row => {
        const formattedRow = Object.fromEntries(row.map((cell, index) => [columns[index].key, cell]));
        return formattedRow;
    });
};
const formatHeaderTable = (columns) => columns.map(column => ({
    key: column.key,
    label: column.name,
    type: column.type,
}));
